export const getRequestcall = async (apiurl, access_token) => {
  try {
    let headers = new Headers();
    if (
      typeof access_token !== "undefined" &&
      access_token !== null &&
      access_token !== ""
    ) {
      headers.append("Authorization", `Bearer ${access_token}`);
    }
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    const callGetrequest = await fetch(
      `${process.env.REACT_APP_BASE_URL}/${apiurl}`,
      {
        headers,
        method: "GET",
      }
    );
    return callGetrequest;
  } catch (error) {}
};
export const GetLocationList = async (address) => {
  // url: `https://maps.googleapis.com/maps/api/place/autocomplete/json?address=${address}&types=geocode&key=${process.env.REACT_APP_MAP_KEY}`,
  const url = `${process.env.REACT_APP_BASE_URL}/api/getLocation?address=${address}&type=geocode`;
  const responce = await fetch(url,{
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "GET",
  })
  .then(res=>{
    return res.json()
  })
  .then(res => res);
  return responce;
};
// Cap Get LOcation list
export const GapLocationList = async (address, country) => {
  const url = `${process.env.REACT_APP_BASE_URL}/api/getLocation?address=${address}&country=${country}&type=geocode`;
  const responce = await fetch(url,{
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "GET",
  })
  .then(res=>{
    return res.json()
  })
  .then(res => res);
  return responce;
};
// Cap Get LOcation list


export function geocodeAddress(address) {
  const geocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?new_forward_geocoder=true&address=${address}&key=${process.env.REACT_APP_MAP_KEY}`;
  // call Geocoding API - https://www.geoapify.com/geocoding-api/
  const result = fetch(geocodingUrl).then(result => result.json())
    .then(res => res);
  return result;
}

const GEOCODE_ROOT_URL = 'https://maps.googleapis.com/maps/api/geocode/json?latlng='

const buildGeocodeUrl = ({longitude, latitude}) => {
  // latitude goes first in query
  return `${GEOCODE_ROOT_URL}${latitude},${longitude}&key=${process.env.REACT_APP_MAP_KEY}`;
};
export const reverseGeocode =async (region) => {
  const url = buildGeocodeUrl(region);
  const results = await fetch(url).then((responce)=>responce.json()).then(res=>res)
  if(results?.status === "OK"){
    const { address_components } = results?.results[0];
    const postal_code = address_components
      .find(component => component.types[0] === 'postal_code');

    if (!postal_code) {
      return "";
    }
    const zip = postal_code.long_name || postal_code.short_name;
    return zip;
  }else{
    return "";
  }
};

